import { jsx as _jsx } from "react/jsx-runtime";
import { shorten } from "shared/misc";
import ThumbnailIcon from "../box/ThumbnailIcon.js";
import { EMBED_TYPES, fileIcon } from "../index.js";
import { useUrl } from "./index.js";
export default function DefaultThumbnail(props) {
    const url = useUrl(props.file.url);
    const canEmbed = EMBED_TYPES.includes(props.file.type);
    if ((props.embed ?? false) && canEmbed) {
        return _jsx("iframe", { src: url, className: "d-block w-100 h-100" });
    }
    else {
        return _jsx(ThumbnailIcon, { icon: fileIcon(props.file.type), children: shorten(props.file.name) });
    }
}
